import { Core } from 'chessboard/core/config/types';
import type { API } from 'chessboard/api/config/types';
import { createCollection } from 'src/utils/create-collection/create-collection';
import type { Game } from 'chessboard/model/game/types';
import type { Board } from 'chessboard/model/board/types';

/**
 * Create reload api method
 */
export function createReload(context: API.Context) {
  /**
   * Reload the current position
   */
  return function reload() {
    const { api, game, respond } = context;

    return respond(Core.APIEvents.Reload, {
      holdSelectedPiece: true,
      pieces: createCollection<Game.Piece.Model, Board.SanSquare>(game.getPieces(true)),
      variant: api.getVariant(),
    });
  };
}
